'use strict';

/** @type {import('./ref')} */
module.exports = ReferenceError;



//////////////////
// WEBPACK FOOTER
// ./~/es-errors/ref.js
// module id = Jo86
// module chunks = 1